import random from 'toxilibs/random.js'
import Level from '../../core/level.js'

const level = new Level({
    name: 'power_zero'
})


// Intruduction puissance 0 - Necessaire pour la suite
level.addQuestion({
    generator: function (q) {
        q.smartChoose([
            {1: random.fairChoiceInt(2, 10, {name: 'base'})},
            {all: random.fairChoiceInt(1, 10, {name: 'base'})}
        ], function (base) {
            q.addMathFormula(base + '^\\color{blue}[0]')
            q.answer = 1
        })
    },
    times: 2

})


export default level
